// extracted by mini-css-extract-plugin
export default {"clearAllChip":"clear-filters-item__clearAllChip___pOeB2","chip":"clear-filters-item__chip___MOSoX"};